// tslint:disable
/**
 * curpValidateMs-develop
 * Versión desarrollo :: API para validación de curp en miic y rizoma
 *
 * The version of the OpenAPI document: 1.0.3-beta
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as globalImportUrl from 'url';
import { Configuration } from './configuration';
import globalAxios, { AxiosPromise, AxiosInstance } from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, RequestArgs, BaseAPI, RequiredError } from './base';

/**
 * Fuente desde donde proviene el CURP
 * @export
 * @enum {string}
 */
export enum Fuente {
    MIIC = 'MIIC',
    RIZOMA = 'RIZOMA'
}

/**
 * 
 * @export
 * @interface Problem
 */
export interface Problem {
    /**
     * An absolute URI that identifies the problem type.  When dereferenced, it SHOULD provide human-readable documentation for the problem type (e.g., using HTML). 
     * @type {string}
     * @memberof Problem
     */
    type?: string;
    /**
     * A short, summary of the problem type. Written in english and readable for engineers (usually not suited for non technical stakeholders and not localized); example: Service Unavailable 
     * @type {string}
     * @memberof Problem
     */
    title?: string;
    /**
     * The HTTP status code generated by the origin server for this occurrence of the problem. 
     * @type {number}
     * @memberof Problem
     */
    status?: number;
    /**
     * A human readable explanation specific to this occurrence of the problem. 
     * @type {string}
     * @memberof Problem
     */
    detail?: string;
    /**
     * An absolute URI that identifies the specific occurrence of the problem. It may or may not yield further information if dereferenced. 
     * @type {string}
     * @memberof Problem
     */
    instance?: string;
}
/**
 * Respuesta de la validación del CURP
 * @export
 * @interface RespuestaValidacion
 */
export interface RespuestaValidacion {
    /**
     * CURP a validar
     * @type {string}
     * @memberof RespuestaValidacion
     */
    curp?: string;
    /**
     * Indica si el CURP fue válido para la firma
     * @type {boolean}
     * @memberof RespuestaValidacion
     */
    valido: boolean;
}
/**
 * Tipo de usuario (usado en Fuente = MIIC)
 * @export
 * @enum {string}
 */
export enum TipoUsuario {
    INTERNO = 'INTERNO',
    EXTERNO = 'EXTERNO'
}

/**
 * Información para validar un CURP
 * @export
 * @interface ValidaCurp
 */
export interface ValidaCurp {
    /**
     * CURP a validar
     * @type {string}
     * @memberof ValidaCurp
     */
    curp: string;
    /**
     * Password del usaurio
     * @type {string}
     * @memberof ValidaCurp
     */
    passwd: string;
    /**
     * 
     * @type {TipoUsuario}
     * @memberof ValidaCurp
     */
    tipoUsuario?: TipoUsuario;
    /**
     * 
     * @type {Fuente}
     * @memberof ValidaCurp
     */
    fuente?: Fuente;
}

/**
 * ValidateApi - axios parameter creator
 * @export
 */
export const ValidateApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Método utilizado para validar que el CURP dado es de la persona que solicita
         * @param {ValidaCurp} [validaCurp] Información para validar la CURP
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        validateCurp: async (validaCurp?: ValidaCurp, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/curp/validate`;
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication oauth required
            // oauth required
            if (configuration && configuration.accessToken) {
                const localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken("oauth", ["jhipster", "email", "profile"])
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }

            // authentication openId required


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            const needsSerialization = (typeof validaCurp !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.data =  needsSerialization ? JSON.stringify(validaCurp !== undefined ? validaCurp : {}) : (validaCurp || "");

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * ValidateApi - functional programming interface
 * @export
 */
export const ValidateApiFp = function(configuration?: Configuration) {
    return {
        /**
         * Método utilizado para validar que el CURP dado es de la persona que solicita
         * @param {ValidaCurp} [validaCurp] Información para validar la CURP
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async validateCurp(validaCurp?: ValidaCurp, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<RespuestaValidacion>> {
            const localVarAxiosArgs = await ValidateApiAxiosParamCreator(configuration).validateCurp(validaCurp, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
    }
};

/**
 * ValidateApi - factory interface
 * @export
 */
export const ValidateApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    return {
        /**
         * Método utilizado para validar que el CURP dado es de la persona que solicita
         * @param {ValidaCurp} [validaCurp] Información para validar la CURP
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        validateCurp(validaCurp?: ValidaCurp, options?: any): AxiosPromise<RespuestaValidacion> {
            return ValidateApiFp(configuration).validateCurp(validaCurp, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * ValidateApi - object-oriented interface
 * @export
 * @class ValidateApi
 * @extends {BaseAPI}
 */
export class ValidateApi extends BaseAPI {
    /**
     * Método utilizado para validar que el CURP dado es de la persona que solicita
     * @param {ValidaCurp} [validaCurp] Información para validar la CURP
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ValidateApi
     */
    public validateCurp(validaCurp?: ValidaCurp, options?: any) {
        return ValidateApiFp(this.configuration).validateCurp(validaCurp, options).then((request) => request(this.axios, this.basePath));
    }

}


